export enum ActivityType {
    Login = 'Login',
    Logout = 'Logout',
    ForcedLogout = 'ForcedLogout',
    Activity = 'Activity',
    Refresh = 'Refresh'
}